import { create } from "zustand"

const useFileStore = create((set) => ({
  selectedFile: null,
  selectedFiles: [],
  setSelectedFile: (file) =>
    set({
      selectedFile: file,
      selectedFiles: file ? [file] : [],
    }),
  setSelectedFiles: (files) => {
    const list = Array.from(files || [])
    set({
      selectedFiles: list,
      selectedFile: list[0] || null,
    })
  },
  clearSelectedFile: () => set({ selectedFile: null, selectedFiles: [] }),
}))

export default useFileStore
